import { Link } from 'react-router-dom';
import styles from "./userProfileHeaderBtn.module.css";
import { useUser } from "../../../hooks/context/useUser";
import { UserAvatar } from '../../common/UserAvatar';

export function UserProfileHeaderBtn() {
  const { user } = useUser();

  if (!user) {
    return null;
  }

  return (
    <Link
      to={`/users/${user.username}`}
      className={styles.avatarLink}
      aria-label={`Go to ${user.username} profile`}
    >
      <UserAvatar
        imageUrl={user.imageUrl}
        username={user.username}
        className={styles.avatar}
      />
    </Link>
  );
}
